import { FC } from "react";

import { useFormContext, useWatch } from "react-hook-form";

import { useRateContext } from "../../Context/RateContext";
import { useRateFieldName } from "../../hooks/useRateFieldName";

import { ShopVariants } from "@/features/LiveFormEditor/Steps/StepTickets/Rates/ShopVariants/ShopVariants";
import { StepTicketsFormData } from "@/features/LiveFormEditor/Steps/StepTickets/types";

interface ShopVariantsFieldProps {
  isInventoryOpen: boolean;
  onInventoryOpenChange: (open: boolean) => void;
}

export const ShopVariantsField: FC<ShopVariantsFieldProps> = ({ isInventoryOpen, onInventoryOpenChange }) => {
  const { rateIndex } = useRateContext();
  const { control, setValue } = useFormContext<StepTicketsFormData>();

  const rateName = useWatch({ control, name: useRateFieldName("name") }) || "";

  return (
    <ShopVariants
      control={control}
      setValue={setValue}
      rateIndex={rateIndex}
      rateName={rateName}
      isInventoryOpen={isInventoryOpen}
      onInventoryOpenChange={onInventoryOpenChange}
    />
  );
};
